<template>

</template>

<script>
export default {

  name: 'NotFound',

  data () {
    return {

    }
  },
  created: function() {
    // Redirect outside the app using plain old javascript
    window.location.href = "/error";
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/NotFound.vue